import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "app-confirm-action-btn",
	templateUrl: "./confirm-action-btn.component.html",
	styleUrls: ["./confirm-action-btn.component.scss"],
})
export class ConfirmActionBtnComponent implements OnInit {
	@Input() btnLabel: string;
	@Input() customStyle = "";
	@Input() disabled = false;

	showPopup = false;
	confirmBtnStyle = `
  width: 250px !important;
  padding: 0px !important;
  height: 40px !important;
  font-size: 22px !important`;

	@Output() confirmed = new EventEmitter();
	@HostListener("document:click", ["$event"])
	onDocumentClick(event: MouseEvent) {
		const target = event.target as HTMLElement;

		if (target.closest(".confirm-button")) {
			return;
		}

		this.showPopup = false;
	}
	constructor(private el: ElementRef) {}

	ngOnInit(): void {}

	onClick() {
		this.showPopup = true;
		// Focus the confirm button after Angular renders the popup
		setTimeout(() => {
			const popupEl = (this.el.nativeElement as HTMLElement).querySelector(".popup");
			if (popupEl) {
				// app-action-button no longer uses Shadow DOM.
				const actionBtnEl = popupEl.querySelector("app-action-button");
				if (actionBtnEl) {
					const innerBtn = actionBtnEl.querySelector<HTMLButtonElement>("button");
					if (innerBtn) {
						innerBtn.focus();
					}
				}
			}
		});
	}

	onConfirm() {
		this.confirmed.emit();
	}
}
